// extracted by mini-css-extract-plugin
module.exports = {"contenedor":"styles_contenedor__uvydm","totalizador":"styles_totalizador__34WLY","ctaWrapper":"styles_ctaWrapper__qPIEG"};